import ImageStackComponent from "./ImageStackComponent";

export default ImageStackComponent;
